@switch (step) {
  @case (Step.One) {
    <rt-app-activation-step-1 (goNext)="changeStep(Step.Two)" (cancel)="cancel()" />
  }
  @case (Step.Two) {
    <rt-app-activation-step-2
      (activated)="activated()"
      (cancel)="cancel()"
      (goBack)="changeStep(Step.One)"
    />
  }
}
